module.exports = __webpack_public_path__ + "static/media/14UNEP5.06e471b9.jpg";